import useOnclickOutside from "react-cool-onclickoutside";
import usePlacesAutocomplete, { getGeocode, getLatLng } from "use-places-autocomplete";
import styles from "./Autocomplete.module.scss";
import React, { ChangeEvent, useEffect } from "react";
import gpsIcon from "../../../assets/images/icons/gps.svg";
import searchIcon from "../../../assets/images/icons/search-normal.svg";
import useAppDispatch from "../../../hooks/useAppDispatch";
import { changeLocation } from "../../../store/userLocation/userLocationSlice";
import { UserLocationAction } from "../../../store/userLocation/userLocationAction";
import useAppSelector from "../../../hooks/useAppSelector";
import { getBrowserLocation } from "../../../helper/geo";
import { fromLatLng } from "react-geocode";

const Autocomplete = () => {
  const dispatch = useAppDispatch();

  const { location } = useAppSelector((state) => state.userLocationSlice);

  useEffect(() => {
    if (location) {
      fromLatLng(location.lat, location.lng).then((res) => {
        setValue(res.results[0].formatted_address, false);
      });
    }
  }, [location]);

  const {
    ready,
    value,
    suggestions: { status, data },
    setValue,
    clearSuggestions,
  } = usePlacesAutocomplete({
    debounce: 300,
  });

  const ref = useOnclickOutside(() => {
    clearSuggestions();
  });

  const handleInput = (e: ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
  };

  const handleSelect = (value: google.maps.places.AutocompletePrediction) => () => {
    setValue(value.description, false);
    clearSuggestions();

    getGeocode({ address: value.description }).then((results) => {
      const placeId = results[0].place_id;
      const { lat, lng } = getLatLng(results[0]);
      dispatch(changeLocation({ lat, lng, placeId }));
      UserLocationAction.setUserLocationToLocal({ lat, lng, placeId });
    });
  };

  const renderSuggestions = () =>
    data.map((suggestion) => {
      const {
        place_id,
        structured_formatting: { main_text, secondary_text },
      } = suggestion;

      return (
        <li className={styles.listItem} key={place_id} onClick={handleSelect(suggestion)}>
          <strong>{main_text}</strong> <small>{secondary_text}</small>
        </li>
      );
    });

  const handleGetGeo = () => {
    getBrowserLocation()
      .then((res: any) => {
        fromLatLng(res.lat, res.lng).then((location) => {
          dispatch(
            changeLocation({ lat: res.lat, lng: res.lng, placeId: location.results[0].place_id })
          );
          UserLocationAction.setUserLocationToLocal({
            lat: res.lat,
            lng: res.lng,
            placeId: location.results[0].place_id,
          });
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div className={styles.root} ref={ref}>
      <img className={styles.searchIcon} src={searchIcon} alt={"search"} />
      <input
        type={"text"}
        className={styles.input}
        value={value}
        onChange={handleInput}
        disabled={!ready}
        placeholder="City..."
      />
      {status === "OK" && <ul className={styles.suggestions}>{renderSuggestions()}</ul>}
      <button onClick={handleGetGeo} className={styles.btn}>
        <img src={gpsIcon} alt={"gps"} />
      </button>
    </div>
  );
};

export default Autocomplete;
